import { OptionalTractorAxlesSchema } from '@src/orders/schemas/AxleInformationInputsSchema';
import { AxleFormName } from '@src/permitField/AxleInformationFields';
import { TractorAxlesFormUtils } from '@src/permitField/TractorAxlesFormUtils';
import {
  TractorActualWeightField,
  TractorGroundHeightField,
  TractorGVWField,
  TractorHeightField,
  TractorLengthField,
  TractorOuterBridgeLengthField,
  TractorUnladenWeightField,
  TractorWheelBaseField,
  TractorWidthField,
} from '@src/permitField/TractorDimensionsFields';
import {
  TractorBodyStyleField,
  TractorFuelTypeField,
  TractorLicensePlateNumberField,
  TractorLicensePlateStateField,
  TractorMakeField,
  TractorModelNumberField,
  TractorTypeField,
  TractorUnitNumberField,
  TractorVINField,
  TractorYearField,
  VehicleOfSpecialDesignField,
} from '@src/permitField/TractorInformationFields';
import {
  TractorLicenseEffectiveDateField,
  TractorLicenseExpirationDateField,
  TractorLicenseIsApportionedPlateField,
  TractorLicensePlateTypeField,
  TractorLicensePlateYearField,
} from '@src/permitField/TractorLicenseFields';
import * as yup from 'yup';

const schemaWithoutAxleCount = {
  [TractorUnitNumberField.fieldName]: TractorUnitNumberField.validator,
  [TractorMakeField.fieldName]: TractorMakeField.validator,
  [TractorVINField.fieldName]: TractorVINField.validator,
  [TractorYearField.fieldName]: TractorYearField.validator,
  [TractorModelNumberField.fieldName]: TractorModelNumberField.validator,
  [TractorTypeField.fieldName]: TractorTypeField.validator,
  [TractorFuelTypeField.fieldName]: TractorFuelTypeField.validator,
  [TractorBodyStyleField.fieldName]: TractorBodyStyleField.validator,
  [VehicleOfSpecialDesignField.fieldName]:
    VehicleOfSpecialDesignField.validator,
  [TractorLicensePlateNumberField.fieldName]:
    TractorLicensePlateNumberField.validator,
  [TractorLicensePlateStateField.fieldName]:
    TractorLicensePlateStateField.validator,
  [TractorLicenseEffectiveDateField.fieldName]:
    TractorLicenseEffectiveDateField.validator.notRequired(),
  [TractorLicenseExpirationDateField.fieldName]:
    TractorLicenseExpirationDateField.validator.notRequired(),
  [TractorLicensePlateTypeField.fieldName]:
    TractorLicensePlateTypeField.validator.notRequired(),
  [TractorLicensePlateYearField.fieldName]:
    TractorLicensePlateYearField.validator.notRequired(),
  [TractorLicenseIsApportionedPlateField.fieldName]:
    TractorLicenseIsApportionedPlateField.validator.notRequired(),
  [TractorLengthField.fieldName]: TractorLengthField.validator.notRequired(),
  [TractorWidthField.fieldName]: TractorWidthField.validator.notRequired(),
  [TractorHeightField.fieldName]: TractorHeightField.validator.notRequired(),
  [TractorWheelBaseField.fieldName]:
    TractorWheelBaseField.validator.notRequired(),
  [TractorGroundHeightField.fieldName]:
    TractorGroundHeightField.validator.notRequired(),
  [TractorUnladenWeightField.fieldName]:
    TractorUnladenWeightField.validator.notRequired(),
  [TractorActualWeightField.fieldName]:
    TractorActualWeightField.validator.notRequired(),
  [TractorGVWField.fieldName]: TractorGVWField.validator.notRequired(),
  [TractorOuterBridgeLengthField.fieldName]:
    TractorOuterBridgeLengthField.validator.notRequired(),
  [TractorAxlesFormUtils.fieldName]: yup.object().shape({
    [AxleFormName]: yup.array(OptionalTractorAxlesSchema).min(1).required(),
  }),
};

//This is the schema when creating/editing a tractor
export const TractorFormInputs = yup.object().shape(schemaWithoutAxleCount);
